import React from "react";
import "./style.scss"
import { useLocaleContext } from "../../../../context/LocaleContext";

export default ({ }) => {
    const { get } = useLocaleContext();
    return (
        <div className="miniplayer-overlay">
            {get('broadcast.overlay.miniplayer.title')}
        </div>
    )
}